import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import { ThemeProvider } from './theme/Theme';
import { store } from './store';
import { setFavouriteIds } from './store/favouritesSlice';
import { loadFavouriteIds } from './store/favouritesStorage';
import './i18n';

import AppLayout from './components/AppLayout';
import SplashScreen from './components/SplashScreen';
import { CartMessageProvider } from './context/CartMessageContext';
import Home from './pages/Home';
import CategoryProducts from './pages/CategoryProducts';
import Search from './pages/Search';
import Cart from './pages/Cart';
import Login from './pages/Login';
import SignIn from './pages/SignIn';
import Favourites from './pages/Favourites';
import Orders from './pages/Orders';
import ProductDetail from './pages/ProductDetail';
import Profile from './pages/Profile';
import DeliveryOffers from './pages/DeliveryOffers';
import PlaceholderPage from './pages/PlaceholderPage';
import DownloadApp from './pages/DownloadApp';

const SPLASH_KEY = 'dr_bardawam_splash_shown';

function FavouritesLoader({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    loadFavouriteIds().then((ids) => dispatch(setFavouriteIds(ids)));
  }, [dispatch]);

  return children;
}

function App() {
  const [showSplash, setShowSplash] = useState(
    () => !sessionStorage.getItem(SPLASH_KEY)
  );

  const handleSplashFinished = useCallback(() => {
    sessionStorage.setItem(SPLASH_KEY, '1');
    setShowSplash(false);
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider>
        <CartMessageProvider>
          <FavouritesLoader>
            {showSplash && <SplashScreen onFinished={handleSplashFinished} />}
            <BrowserRouter>
              <Routes>
                <Route element={<AppLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/category/:categoryId" element={<CategoryProducts />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/register" element={<Login />} />
                  <Route path="/signin" element={<SignIn />} />
                  <Route path="/product/:productId" element={<ProductDetail />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/favourites" element={<Favourites />} />
                  <Route path="/delivery" element={<DeliveryOffers />} />
                  <Route path="/offers" element={<DeliveryOffers />} />
                  <Route path="/download" element={<DownloadApp />} />
                  <Route path="/notifications" element={<PlaceholderPage titleKey="notifications_title" />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </FavouritesLoader>
        </CartMessageProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
